import React from 'react';

const SvgLoading = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M6.539 7.858c2.054-2.714 5.865-3.542 8.886-1.797 3.022 1.744 4.21 5.458 2.886 8.594l1.5.866c1.788-3.963.313-8.727-3.529-10.945S7.577 3.462 5.04 6.993l1.499.865zM5.212 12.93a6.827 6.827 0 01.47-3.587l-1.5-.866a8.497 8.497 0 00-.63 4.898l1.66-.445zm2.265 4.219a6.88 6.88 0 01-1.822-2.563l-1.66.444a8.543 8.543 0 002.512 3.55l.97-1.431zm3.692 1.648a6.82 6.82 0 01-2.27-.688l-.967 1.425a8.512 8.512 0 003.246.981l-.01-1.718zm3.372-.45a6.922 6.922 0 01-1.657.44l.008 1.72a8.75 8.75 0 002.488-.647l-.84-1.513z" />
  </svg>
);

export default SvgLoading;
